var render = function render(){var _vm=this,_c=_vm._self._c;return _c('service-screen-layout',{attrs:{"parts":_vm.parts},scopedSlots:_vm._u([{key:"details",fn:function(){return [_c('LiquidLayer2LineDetails',{attrs:{"liquidLayer2Line":_vm.saleDefinition.definition.liquidLayer2Line},on:{"saveSale":_vm.saveSale}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }